module.exports = __webpack_public_path__ + "img/rapier.ca75585e.svg";